window.FREYA_PRODUCT_SPINS = {
  "/products/cilek-jalapeno-sos": {
    "src": window.FREYA_ASSET_URLS['cilek-jalapeno-360.mp4'],
    "turns": 2
  },
  "/products/ubeli-mor-granola": {
    "src": window.FREYA_ASSET_URLS['ubeli-mor-granola-360.mp4'],
    "turns": 1
  },
  "/products/aci-biberli-zeytinyagi": {
    "src": window.FREYA_ASSET_URLS['aci-biberli-zeytinyagi-360.mp4'],
    "turns": 1
  },
  "/products/klasik-humus": {
    "src": window.FREYA_ASSET_URLS['klasik-humus-360.mp4'],
    "turns": 1
  },
  "/products/kopya-baharatli-balkabagi": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-05.mp4'],
    "turns": 1
  },
  "/products/carkifelek-sosu": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-06.mp4'],
    "turns": 1
  },
  "/products/cikolatali-granola": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-07.mp4'],
    "turns": 1
  },
  "/products/ejder-meyvesi-sosu": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-08.mp4'],
    "turns": 1
  },
  "/products/hindistan-cevizi-granola": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-09.mp4'],
    "turns": 1
  },
  "/products/i%CC%87ncir-balsamik-sos": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-10.mp4'],
    "turns": 1
  },
  "/products/jalapeno-biberli-humus": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-11.mp4'],
    "turns": 1
  },
  "/products/kuru-meyveli-granola": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-12.mp4'],
    "turns": 1
  },
  "/products/matcha-granola": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-13.mp4'],
    "turns": 1
  },
  "/products/maviyemis-lavanta-sos": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-14.mp4'],
    "turns": 1
  },
  "/products/mini-sos-kutusu": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-15.mp4'],
    "turns": 1
  },
  "/products/pancar-havlican-sosu": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-16.mp4'],
    "turns": 1
  },
  "/products/pancarli-humus": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-17.mp4'],
    "turns": 1
  },
  "/products/visne-ve-iskin-otu-sosu": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-18.mp4'],
    "turns": 1
  },
  "/products/visne-salsa-sosu": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-19.mp4'],
    "turns": 1
  },
  "/products/zencefil-ve-acili-armut-sosu": {
    "src": window.FREYA_ASSET_URLS['catalog-spin-20.mp4'],
    "turns": 1
  }
};
